import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[kui-menu-actions]',
    standalone: false
})
export class KuiMenuActionsDirective {
    @HostBinding('class.menu-actions') menuActionsClass = true;
}
